<mat-card class="{{level}} mat-elevation-z0" [style.max-width]="maxWidth">
  <mat-card-content>
    <div *ngIf="!hideTitle" class="info-card-title">
      <mat-icon>{{level}}</mat-icon>
      <div>{{(title || (level | titlecase)) | translate : locale.language}}</div>
    </div>
    <ng-container *ngIf="message">{{message| translate : locale.language}}</ng-container>
    <ng-content></ng-content>
  </mat-card-content>
</mat-card>
